'use client';

import { Box, VStack } from '@terra/ui-styled-system';
import { Text } from '../../../';
import type { TerraIcon } from '@terra/ui-icons';

interface AssetTabDrawerEmptyStateProps {
  icon: TerraIcon;
  title: string;
  description: string;
  hideBorder?: boolean;
}

export function AssetTabDrawerEmptyState({
  icon: Icon,
  title,
  description,
  hideBorder = false,
}: AssetTabDrawerEmptyStateProps) {
  return (
    <Box
      w="full"
      h="fit-content"
      borderWidth={hideBorder ? 0 : '1px'}
      borderColor="border.subtle"
      borderRadius="md"
      bg="bg.light"
      p={6}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <VStack gap={6} alignItems="center">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          color="bg.disabled"
        >
          <Icon size={40} />
        </Box>
        <VStack gap={2} alignItems="center">
          <Text fontSize="md" fontWeight="medium" color="fg.default">
            {title}
          </Text>
          <Text
            fontSize="md"
            fontWeight="regular"
            color="fg.muted"
            textAlign="center"
          >
            {description}
          </Text>
        </VStack>
      </VStack>
    </Box>
  );
}
